// Base API URL without path - we'll add /public or /protected dynamically
export const apiBaseUrl = `https://apiv2.${process.env.REACT_APP_DOMAIN}`;

// Legacy support - will be removed after migration
export const apiGatewayUrlParam = `${apiBaseUrl}/service/`;

export const publicContentUrl = `https://public.content.${process.env.REACT_APP_DOMAIN}/`;

// New API paths for two-proxy architecture
export const publicApiPath = '/public/';
export const protectedApiPath = '/protected/';
